// Modules
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { GenericFormModule } from '../generic-form/generic-form.module';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { ChipModule } from 'primeng/chip';

// Services
import { GenericCrudService } from './service/generic-crud.service';

// Component
import { EditableTableComponent } from './components/editable-table/editable-table.component';
import { BaseTableComponent } from './components/base-table.component';
import { EditableTabComponent } from './components/editable-tab/editable-tab.component';
import { CreateUpdateFormComponent } from './components/create-update-form/create-update-form.component';

@NgModule({
	imports: [
		GenericFormModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TableModule,
		ToastModule,
		ConfirmDialogModule,
		DropdownModule,
		InputTextModule,
		InputSwitchModule,
		TabViewModule,
		PanelModule,
		CheckboxModule,
		ButtonModule,
		ChipModule
	],
	declarations: [CreateUpdateFormComponent, BaseTableComponent, EditableTableComponent, EditableTabComponent],
	exports: [CreateUpdateFormComponent, BaseTableComponent, EditableTableComponent, EditableTabComponent],
	providers: [GenericCrudService]
})
export class GenericCrudModule {}
